import React from 'react'
import { Box, Chip, Tooltip } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import Flag from '../../mailTemplate/src/components/atomic/atoms/Flag'

const CampaignHeader = ({ campaignDetails }) => {
  if (!campaignDetails) return null

  const productNames = campaignDetails?.productName || []

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      {/* Flags */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Flag
          code={campaignDetails?.currentCountryCode}
          square
          style={{
            fontSize: '1.25rem',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        />
        <ArrowForward sx={{ color: 'text.disabled', fontSize: '0.875rem' }} />
        <Flag
          code={campaignDetails?.importerCountryCodes?.[0]}
          square
          style={{
            fontSize: '1.25rem',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        />
      </Box>

      {/* Products */}
      {productNames.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center' }}>
          {productNames.slice(0, 2).map((product, index) => (
            <Chip
              key={index}
              label={product}
              size="small"
              sx={{
                borderRadius: 1,
                height: 20,
                fontSize: '0.7rem',
                backgroundColor: 'transparent',
                border: '1px solid',
                borderColor: 'divider',
                '& .MuiChip-label': { px: 0.75 }
              }}
            />
          ))}
          {productNames.length > 2 && (
            <Tooltip title={productNames.slice(2).join(', ')} arrow>
              <Chip
                label={`+${productNames.length - 2}`}
                size="small"
                sx={{
                  borderRadius: 1,
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'transparent',
                  border: '1px solid',
                  borderColor: 'divider',
                  fontWeight: 500,
                  '& .MuiChip-label': { px: 0.75 }
                }}
              />
            </Tooltip>
          )}
        </Box>
      )}
    </Box>
  )
}

export default CampaignHeader
